import React from 'react';
import { Modal, Button } from 'antd';
import isEqual from 'lodash/isEqual';
import CrossIcon from '../../../Svgs/CrossIcon';
import { FaRegCheckCircle } from 'react-icons/fa';
import '../../../assets/styles/global.scss';
import '../styles/CategoryFilter.scss'
import Accessories from '../../../Svgs/filters/Accessories';
import Appliances from '../../../Svgs/filters/Appliances';
import Art from '../../../Svgs/filters/Art';
import BathFixture from '../../../Svgs/filters/BathFixture';
import ConfFurniture from '../../../Svgs/filters/ConfFurniture';
import Finishes from '../../../Svgs/filters/Finishes';
import Flooring from '../../../Svgs/filters/Flooring';
import Furniture from '../../../Svgs/filters/Furniture';
import F_A_Additions from '../../../Svgs/filters/F_A_Additions';
import F_A_Enterprise from '../../../Svgs/filters/F_A_Enterprise';

import Interiors_Signage from '../../../Svgs/filters/Interiors_Signage';
import IT from '../../../Svgs/filters/IT';
import Lighting from '../../../Svgs/filters/Lighting';
import Office_Furniture from '../../../Svgs/filters/Office_Furntiture';
import Office_Furniture_Pre_Fabs from '../../../Svgs/filters/Office_Furniture_Pre_Fabs';
import OperationalAssets from '../../../Svgs/filters/OperationalAssets';
import Plants from '../../../Svgs/filters/Plants';
import Plumbing_Fixtures from '../../../Svgs/filters/Plumbing_Fixtures';
import Studio_Art from '../../../Svgs/filters/Studio_Art';
import Vendor_Art from '../../../Svgs/filters/Vendor_Art';
import Wwlo_Furniture from '../../../Svgs/filters/Wwlo_Furniture';
import Other from '../../../Svgs/filters/Other';
// import '../styles/searchBar.scss';


class CustomSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allCategories: [
                { label: "Accessories", value: false, Icon: <Accessories /> },
                { label: "Appliances", value: false, Icon: <Appliances /> },
                { label: "Art", value: false, Icon: <Art /> },
                { label: "Bathroom Fixtures", value: false, Icon: <BathFixture /> },
                { label: "Conf Furniture", value: false, Icon: <ConfFurniture /> },
                { label: "F&A Additions", value: false, Icon: <F_A_Additions /> },
                { label: "F&A Enterprise", value: false, Icon: <F_A_Enterprise /> },
                { label: "Finishes", value: false, Icon: <Finishes /> },
                { label: "Flooring", value: false, Icon: <Flooring /> },
                { label: "Furniture", value: false, Icon: <Furniture /> },
                { label: "IT", value: false, Icon: <IT /> },
                { label: "Interior Signage", value: false, Icon: <Interiors_Signage /> },
                { label: "Lighting", value: false, Icon: <Lighting /> },
                { label: "Office Furniture", value: false, Icon: <Office_Furniture /> },
                { label: "Office Furniture & Pre-Fabs", value: false, Icon: <Office_Furniture_Pre_Fabs /> },
                { label: "Operational Assets", value: false, Icon: <OperationalAssets /> },
                { label: "Plants", value: false, Icon: <Plants /> },
                { label: "Plumbing Fixtures", value: false, Icon: <Plumbing_Fixtures /> },
                { label: "Studio Art", value: false, Icon: <Studio_Art /> },
                { label: "Vendor Art", value: false, Icon: <Vendor_Art /> },
                { label: "WWLO Furniture", value: false, Icon: <Wwlo_Furniture /> },
                { label: "Others", value: false, Icon: <Other /> }],
            disableBtn: true,
        }
    }

    componentDidMount() {
        const { filters } = this.props;
        if (filters && filters.length > 0) {
            this.setFiltersState();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!isEqual(this.props.filters, prevProps.filters)) {
            this.setToInitialState();
            this.setFiltersState();
        }
        if (!isEqual(this.state.allCategories, prevState.allCategories)) {
            const { allCategories } = this.state;
            let disable = true;
            allCategories.forEach(obj => {
                if (obj.value === true)
                    disable = false;
            });
            this.setState({
                disableBtn: disable
            })
        }
    }

    setToInitialState = () => {
        let categories = [
            { label: "Accessories", value: false, Icon: <Accessories /> },
            { label: "Appliances", value: false, Icon: <Appliances /> },
            { label: "Art", value: false, Icon: <Art /> },
            { label: "Bathroom Fixtures", value: false, Icon: <BathFixture /> },
            { label: "Conf Furniture", value: false, Icon: <ConfFurniture /> },
            { label: "F&A Additions", value: false, Icon: <F_A_Additions /> },
            { label: "F&A Enterprise", value: false, Icon: <F_A_Enterprise /> },
            { label: "Finishes", value: false, Icon: <Finishes /> },
            { label: "Flooring", value: false, Icon: <Flooring /> },
            { label: "Furniture", value: false, Icon: <Furniture /> },
            { label: "IT", value: false, Icon: <IT /> },
            { label: "Interior Signage", value: false, Icon: <Interiors_Signage /> },
            { label: "Lighting", value: false, Icon: <Lighting /> },
            { label: "Office Furniture", value: false, Icon: <Office_Furniture /> },
            { label: "Office Furniture & Pre-Fabs", value: false, Icon: <Office_Furniture_Pre_Fabs /> },
            { label: "Operational Assets", value: false, Icon: <OperationalAssets /> },
            { label: "Plants", value: false, Icon: <Plants /> },
            { label: "Plumbing Fixtures", value: false, Icon: <Plumbing_Fixtures /> },
            { label: "Studio Art", value: false, Icon: <Studio_Art /> },
            { label: "Vendor Art", value: false, Icon: <Vendor_Art /> },
            { label: "WWLO Furniture", value: false, Icon: <Wwlo_Furniture /> },
            { label: "Others", value: false, Icon: <Other /> }];
        this.setState({
            allCategories: categories,
            disableBtn: true,
        });
        this.props.setFilter([]);
    }

    setFiltersState = () => {
        const { filters } = this.props;
        const { allCategories } = this.state;
        if (filters && filters.length > 0) {
            const tempCategories = allCategories.map(category => {
                if (filters.find(selectedCategory => selectedCategory === category.label))
                    return { label: category.label, value: true, Icon: category.Icon }
                return category;
            });
            this.setState({ allCategories: tempCategories });
            this.setState({ disableBtn: false });
        }
    }

    applyAllFilters = () => {
        const { setFilter, closeFilter } = this.props;
        const { allCategories } = this.state;
        let tempCategories = [];
        allCategories.forEach(obj => {
            if (obj.value === true)
                tempCategories = [...tempCategories, obj.label]
        });
        setFilter(tempCategories);
        closeFilter();
    }

    changeFilterState = (name, flag, Icon) => {
        const { allCategories } = this.state;
        let tempCategories = allCategories.map(obj => {
            if (name === obj.label)
                return { label: obj.label, value: flag, Icon: obj.Icon }
            return obj;
        });
        this.setState({ allCategories: tempCategories })
    }

    render() {
        const { visible, handleCancel } = this.props;
        const {
            allCategories,
            disableBtn,
        } = this.state;
        return (
            <>
                <div>
                    <table class="table m-t-5">
                        <>
                            {
                                allCategories.map((obj, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="div-column-switch-left">
                                                <div className="icon-flex">
                                                    {obj.Icon}
                                                </div>
                                                <span className="text">{obj.label}</span>
                                            </td>
                                            <td className="div-column-switch-right align-switch switch-outer">
                                                <div className="filter-div">
                                                    {obj.value ? <div className="Checked" onClick={() => this.changeFilterState(obj.label, !obj.value, obj.Icon)}>
                                                        <FaRegCheckCircle size={24} color='#6554C1' />
                                                    </div> : <span className="unChecked" onClick={() => this.changeFilterState(obj.label, !obj.value, obj.Icon)} />}
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </>
                        <tr className="m-t-10 height-13" >
                        </tr>
                    </table>
                </div>
                <div className="button-section">
                    <Button className="button-grey m-r-12" onClick={() => {
                        if (this.props.filters.length > 0) this.setToInitialState();
                        this.props.closeFilter();
                    }}>Clear</Button>
                    <Button className="button-green" disabled={disableBtn} onClick={() => this.applyAllFilters()}>Apply</Button>
                </div>
            </>
        );
    }
}
export default CustomSelect;